import { useState } from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { validateProjectToken } from "../api/FlaskAPI";
import { getErrorMessage } from "../api/errors";
import { useTranslation } from "react-i18next";

export default function ProjectTokenDialog({ open, onClose, onSuccess }) {
  const { t } = useTranslation();
  const [token, setToken] = useState("");
  const [validating, setValidating] = useState(false);
  const [error, setError] = useState("");

  const handleClose = () => {
    setToken("");
    setError("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const trimmed = token.trim();
    if (!trimmed) {
      setError(t("token.required"));
      return;
    }

    setValidating(true);
    try {
      await validateProjectToken({ token: trimmed });
      onSuccess(trimmed);
      setToken("");
    } catch (err) {
      setError(getErrorMessage(err, t("token.invalid")));
    } finally {
      setValidating(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle sx={{ fontWeight: 700 }}>{t("token.title")}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {t("token.body")}
          </Typography>
          <TextField
            label={t("token.label")}
            value={token}
            onChange={(e) => setToken(e.target.value)}
            fullWidth
            autoFocus
            disabled={validating}
            error={!!error}
            helperText={error}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            disabled={validating}
            sx={{ textTransform: "none" }}
          >
            {t("common.cancel")}
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={validating || !token.trim()}
            sx={{ textTransform: "none" }}
          >
            {validating ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              t("token.continue")
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
